webpackJsonp([99],{

/***/ "5OHe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_vue@2.5.13@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("VCXJ");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.2@babel-loader/lib!./node_modules/_vue-loader@13.7.0@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.0@vue-loader/lib/template-compiler?{"id":"data-v-0e7aa0da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("of87")
}
var normalizeComponent = __webpack_require__("X4nt")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vue-router@3.0.1@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("zO6J");

// CONCATENATED MODULE: ./src/router/index.js


// 主页引导页
var Index = function Index(resolve) {
  return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0dD+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 首页
var Home = function Home(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jOPF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 首页推荐信用卡列表页
var HostCard = function HostCard(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(96)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QHFi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 活动页
var Activity = function Activity(resolve) {
  return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YeT/")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 活动细则页
var ActivityRules = function ActivityRules(resolve) {
  return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ewIT")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 测试内容页
var Content = function Content(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(97)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("esWs")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 登录
var Login = function Login(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(95)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A1kB")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 注册1
var registerA = function registerA(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wLWC")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 注册2
var registerB = function registerB(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(71)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TKyj")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 手机绑定
var mobileBinding = function mobileBinding(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/hy+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 手机绑定重置密码
var MobileresetPassword = function MobileresetPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(74)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2rZf")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 忘记密码
var forgotPassword = function forgotPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(76)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k17D")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 重置密码
var resetPassword = function resetPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(75)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("352p")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 分享
// 分享首页
var ShareIndex = function ShareIndex(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Hpay")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 专题栏位页
var ChannelIndex = function ChannelIndex(resolve) {
  return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xCT1")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 作者页
var AuthorIndex = function AuthorIndex(resolve) {
  return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0UtD")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 添加好友备注页
var addRemarks = function addRemarks(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EbDY")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 新增文章页
var AddArticle = function AddArticle(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(90)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ouuN")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 文章详情页
var ArticleDetails = function ArticleDetails(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k23d")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 发表评论页
var Comment = function Comment(resolve) {
  return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hkU6")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 其他用户中心页
var OtherUserPages = function OtherUserPages(resolve) {
  return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Z/Cz")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 用户中心
// 用户中心首页
var UserIndex = function UserIndex(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Th+4")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 联系客服页
var Customer = function Customer(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(91)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CajV")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 设置页
var SetUpIndex = function SetUpIndex(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tm4T")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 设置页-重置密码
var setPassword = function setPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ivsx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 重置支付密码
var setPayPassword = function setPayPassword(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("np1p")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 重置登录密码
var setLoginPassword = function setLoginPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lmgw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 再次输入密码页面
var setSecLoginPassword = function setSecLoginPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dBdm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 设置新密码页面
var setNewLoginPassword = function setNewLoginPassword(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0O6s")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 不记得支付密码
var setPayPasswordFoget = function setPayPasswordFoget(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wOx6")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 短信验证码输入多次之后，跳转到图片验证码页面
var setPayPasswordFoget1 = function setPayPasswordFoget1(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("clBN")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 输入身份证号码验证页面
var setShotMessageValidate = function setShotMessageValidate(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("69Li")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 记得支付密码
var setPayPasswordRember1 = function setPayPasswordRember1(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dfcb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//  重新设置支付密码
var setPayPasswordRember2 = function setPayPasswordRember2(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jl+h")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 再次输入种重置的密码
var setPayPasswordRember3 = function setPayPasswordRember3(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EqCP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 意见反馈页
var OpinionFeedback = function OpinionFeedback(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pXzb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 关于我们页
var AboutUs = function AboutUs(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sV8H")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 个人信息页
var PersonalInfo = function PersonalInfo(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(88)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6CvB")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 昵称修改页
var NicknameModify = function NicknameModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UC0t")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 签名修改页
var SignatureModify = function SignatureModify(resolve) {
  return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("frd3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 性别修改页
var SexModify = function SexModify(resolve) {
  return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NzXx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 年龄修改页
var ageModify = function ageModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Uuk1")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 个人信息修改页
var MyselfModify = function MyselfModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("npLz")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 房产信息修改页
var PropertyModify = function PropertyModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Jijh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 房产信息维护修改页
var PropertyManageModify = function PropertyManageModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zs1E")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 房产信息新增页面
var PropertyAdd = function PropertyAdd(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AK51")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 车产信息修改页
var CarModify = function CarModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VgU2")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 车产信息维护修改页
var CarManageModify = function CarManageModify(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bCjj")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 车产信息新增页面
var CarInfoAdd = function CarInfoAdd(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("le3m")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 金融信息-登陆密码验证页
var FinancialVerification = function FinancialVerification(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FN+N")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 实名认证页
var RealName = function RealName(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ls2l")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 扫描页
var RealScanning = function RealScanning(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jycI")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 详细地址地图选择页
var AddressMap = function AddressMap(resolve) {
  return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("alJj")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 我的文章列表页
var MyArticleList = function MyArticleList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fDie")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 我的收藏列表页
var MyCollectionList = function MyCollectionList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0oBM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 我的关注列表页
var MyConcernsList = function MyConcernsList(resolve) {
  return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SLij")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 我的粉丝列表页
var MyFanList = function MyFanList(resolve) {
  return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZLgH")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 我的银行卡列表页
var MyBankCardList = function MyBankCardList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("w16+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 添加银行卡页A
var AddBankCardA = function AddBankCardA(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l5Rr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 添加银行卡页B
var AddBankCardB = function AddBankCardB(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oyGX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 添加银行卡页C
var AddBankCardC = function AddBankCardC(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FNmA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 添加银行卡页D
var AddBankCardD = function AddBankCardD(resolve) {
  return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kCZ4")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 公司税号列表页
var CompanyTaxList = function CompanyTaxList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UMRt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 公司添加税号页
var CompanyAddDuty = function CompanyAddDuty(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pRdI")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 公司税号详情页
var CompanyDetails = function CompanyDetails(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GIps")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 公司税号编辑页
var CompanyEdit = function CompanyEdit(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T5OM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 公司税号扫一扫页
var CompanyScan = function CompanyScan(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XeoX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 系统通知页
var SystemNotice = function SystemNotice(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wpUC")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 动态通知页
var DynamicNotice = function DynamicNotice(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HNsL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 网申
// 网申卡银行选择列表页
var NetCardSelectList = function NetCardSelectList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2+0o")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 网申卡产品选择列表页
var NetCardProductList = function NetCardProductList(resolve) {
  return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QOYL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 网申卡详情页
var NetCardDetails = function NetCardDetails(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uMz2")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 网申卡评价列表
var NetCardEvaluate = function NetCardEvaluate(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(69)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("csYo")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申卡信息填写页A
var NetCardInfoFillingA = function NetCardInfoFillingA(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ay25")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申卡信息填写页B
var NetCardInfoFillingB = function NetCardInfoFillingB(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(67)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aU+1")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申卡信息填写页C
var NetCardInfoFillingC = function NetCardInfoFillingC(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xeTP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申卡完成页
var NetCardInfoFillingD = function NetCardInfoFillingD(resolve) {
  return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KQX5")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申请须知
var NetCardNoticeA = function NetCardNoticeA(resolve) {
  return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EkW8")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 领用合约
var NetCardNoticeB = function NetCardNoticeB(resolve) {
  return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HHdg")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申请人声明
var NetCardNoticeC = function NetCardNoticeC(resolve) {
  return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4u4V")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 芝麻信用协议
var NetCardNoticeD = function NetCardNoticeD(resolve) {
  return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mvt1")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 进度查询申请列表页
var ScheduleQueryList = function ScheduleQueryList(resolve) {
  return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XxNO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 进度查询结果详情页
var QueryResultsDetails = function QueryResultsDetails(resolve) {
  return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ipmt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 进度查询银行列表页
var QueryBankCardList = function QueryBankCardList(resolve) {
  return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9D4m")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申请评价列表页
var EvaluateList = function EvaluateList(resolve) {
  return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NDK8")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申请评价录入页
var EvaluateEntry = function EvaluateEntry(resolve) {
  return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("haTf")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 申请评价详情页
var EvaluateDetails = function EvaluateDetails(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(62)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0xI+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 理财
// 理财产品列表页
var ConductFinList = function ConductFinList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SKQ+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 错误页
var Error = function Error(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(89)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+T3Y")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 积分商城
// 积分安全检查页
var SecurityCheck = function SecurityCheck(resolve) {
  return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iWeP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 商品列表页
var GoodsList = function GoodsList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(79)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uyY3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 券包列表页
var CouponList = function CouponList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(80)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OYkT")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 用户中心订单列表页
var OrderList = function OrderList(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(77)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RftQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 评价列表页(预留)
var EvaluationList = function EvaluationList(resolve) {
  return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jWm3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 订单详情页
var OrderDetails = function OrderDetails(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(82)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("amJh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 订单发表评价页
var PubEvaluation = function PubEvaluation(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(83)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Afec")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// 下载页
var Download = function Download(resolve) {
  return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1HzE")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    meta: {
      title: ''
    }
  }, {
    path: '/Home',
    component: Home,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/HostCard',
    component: HostCard,
    meta: {
      title: '信用卡'
    }
  }, {
    path: '/Activity/Index',
    component: Activity,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Error',
    component: Error,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Activity/ActivityRules',
    component: ActivityRules,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Index/Content/:id',
    component: Content,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/Login',
    component: Login,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/register/registerA',
    component: registerA,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/registerB/:loginId',
    component: registerB,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/MobileBinding/MobileBinding',
    component: mobileBinding,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/MobileBinding/MobileresetPassword/:mobile',
    component: MobileresetPassword,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/ForgotPassword/forgotPassword/:mobile',
    component: forgotPassword,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/Login/ForgotPassword/resetPassword/:mobile',
    component: resetPassword,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/ShareIndex/Index',
    component: ShareIndex,
    meta: {
      title: '分 享',
      keepAlive: true
    }
  }, {
    path: '/ShareIndex/Channel',
    component: ChannelIndex,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/ShareIndex/Author/:authId',
    component: AuthorIndex,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/ShareIndex/addRemarks/:authId/:nickName',
    component: addRemarks,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/Article/AddArticle',
    component: AddArticle,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/Article/ArticleDetails/:id',
    component: ArticleDetails,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/Article/Comment',
    component: Comment,
    meta: {
      title: '分 享'
    }
  }, {
    path: '/OtherUserPages/OtherUserPages',
    component: OtherUserPages,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/UserIndex/Index',
    component: UserIndex,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/UserIndex/Customer',
    component: Customer,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/UserCenter/SetUp/Index',
    component: SetUpIndex,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPassword',
    component: setPassword,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPassword',
    component: setPayPassword,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setLoginPassword',
    component: setLoginPassword,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setSecLoginPassword/:oldPwd/:pwd',
    component: setSecLoginPassword,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setNewLoginPassword/:oldPwd',
    component: setNewLoginPassword,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPasswordFoget',
    component: setPayPasswordFoget,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPasswordFoget1',
    component: setPayPasswordFoget1,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setShotMessageValidate',
    component: setShotMessageValidate,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPasswordRember1',
    component: setPayPasswordRember1,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPasswordRember2',
    component: setPayPasswordRember2,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/setPayPasswordRember3/:Pwd',
    component: setPayPasswordRember3,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/OpinionFeedback',
    component: OpinionFeedback,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/SetUp/AboutUs',
    component: AboutUs,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/Index',
    component: PersonalInfo,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/NicknameModify/:nickName',
    component: NicknameModify,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/SignatureModify/:signature',
    component: SignatureModify,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/ageModify/:age',
    component: ageModify,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/SexModify',
    component: SexModify,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/MyselfModify',
    component: MyselfModify,
    meta: {
      title: '用户中心'
    }
  }, {
    path: '/MyInfo/PropertyModify',
    component: PropertyModify,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyInfo/PropertyManageModify',
    component: PropertyManageModify,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyInfo/PropertyAdd',
    component: PropertyAdd,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyInfo/CarModify',
    component: CarModify,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyInfo/CarManageModify',
    component: CarManageModify,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyInfo/CarInfoAdd',
    component: CarInfoAdd,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/FinancialInfor/Index',
    component: FinancialVerification,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/RealName/Scanning/:cid',
    component: RealScanning,
    meta: {
      title: '实名认证'
    }
  }, {
    path: '/RealName/Index/:cid',
    component: RealName,
    meta: {
      title: '实名认证'
    }
  }, {
    path: '/RealName/AddressMap',
    component: AddressMap,
    meta: {
      title: '伴 儿'
    }
  }, {
    path: '/MyList/MyArticleList',
    component: MyArticleList,
    meta: {
      title: '我的文章'
    }
  }, {
    path: '/MyList/CollectionList',
    component: MyCollectionList,
    meta: {
      title: '我的收藏'
    }
  }, {
    path: '/MyList/ConcernsList',
    component: MyConcernsList,
    meta: {
      title: '我的关注'
    }
  }, {
    path: '/MyList/FanList',
    component: MyFanList,
    meta: {
      title: '我的粉丝'
    }
  }, {
    path: '/MyBankCard/Index',
    component: MyBankCardList,
    meta: {
      title: '我的银行卡'
    }
  }, {
    path: '/MyBankCard/AddBankCardA',
    component: AddBankCardA,
    meta: {
      title: '添加银行卡'
    }
  }, {
    path: '/MyBankCard/AddBankCardB/:card',
    component: AddBankCardB,
    meta: {
      title: '添加银行卡'
    }
  }, {
    path: '/MyBankCard/AddBankCardC/:card/:mobile/:isPic',
    component: AddBankCardC,
    meta: {
      title: '添加银行卡'
    }
  }, {
    path: '/MyBankCard/AddBankCardD',
    component: AddBankCardD,
    meta: {
      title: '我的银行卡'
    }
  }, {
    path: '/CompanyTax/Index',
    component: CompanyTaxList,
    meta: {
      title: '公司税号'
    }
  }, {
    path: '/CompanyTax/AddDuty',
    component: CompanyAddDuty,
    meta: {
      title: '添加税号'
    }
  }, {
    path: '/CompanyTax/Details/:dId',
    component: CompanyDetails,
    meta: {
      title: '税号详情'
    }
  }, {
    path: '/CompanyTax/Edit/:id',
    component: CompanyEdit,
    meta: {
      title: '修改税号'
    }
  }, {
    path: '/CompanyTax/Scan/:dId',
    component: CompanyScan,
    meta: {
      title: '公司税号'
    }
  }, {
    path: '/Notice/Index',
    component: SystemNotice,
    meta: {
      title: '消 息'
    }
  }, {
    path: '/Notice/DynamicNotice',
    component: DynamicNotice,
    meta: {
      title: '消 息'
    }
  }, {
    path: '/ApplicationCard/Index',
    component: NetCardSelectList,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/ProductList/:bankId',
    component: NetCardProductList,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/Details/:id',
    component: NetCardDetails,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/Evaluate/:id',
    component: NetCardEvaluate,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/InfoFillingA/:id',
    component: NetCardInfoFillingA,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/InfoFillingB/:id',
    component: NetCardInfoFillingB,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/InfoFillingC/:id',
    component: NetCardInfoFillingC,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/InfoFillingD',
    component: NetCardInfoFillingD,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/NoticeA',
    component: NetCardNoticeA,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/NoticeB',
    component: NetCardNoticeB,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/NoticeC',
    component: NetCardNoticeC,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ApplicationCard/NoticeD',
    component: NetCardNoticeD,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ScheduleQuery/Index',
    component: ScheduleQueryList,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ScheduleQuery/ResultsDetails/:id',
    component: QueryResultsDetails,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/ScheduleQuery/BankCardList',
    component: QueryBankCardList,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/Evaluate/Index',
    component: EvaluateList,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/Evaluate/Entry/:id',
    component: EvaluateEntry,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/Evaluate/Details/:id',
    component: EvaluateDetails,
    meta: {
      title: '信用卡网申'
    }
  }, {
    path: '/Conduct/Index/:id',
    component: ConductFinList,
    meta: {
      title: '理财推荐'
    }
  }, {
    path: '/Security/Index/:typeId/:baner',
    component: SecurityCheck,
    meta: {
      title: ''
    }
  }, {
    path: '/List/Index/:baner',
    component: GoodsList,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/List/Coupon/:baner',
    component: CouponList,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/Order/Index/:typeId/:baner',
    component: OrderList,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/Order/EvaluationList',
    component: EvaluationList,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/Details/Index/:id',
    component: OrderDetails,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/Details/Evaluation/:orderNo/:goodId',
    component: PubEvaluation,
    meta: {
      title: '积券通'
    }
  }, {
    path: '/Download',
    component: Download,
    meta: {
      title: ''
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));
// EXTERNAL MODULE: ./node_modules/_axios@0.17.1@axios/index.js
var _axios_0_17_1_axios = __webpack_require__("2sCs");
var _axios_0_17_1_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_17_1_axios);

// EXTERNAL MODULE: ./node_modules/_vuex@3.0.1@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("9rMa");

// EXTERNAL MODULE: ./node_modules/_mint-ui@2.2.13@mint-ui/lib/mint-ui.common.js
var mint_ui_common = __webpack_require__("wSez");
var mint_ui_common_default = /*#__PURE__*/__webpack_require__.n(mint_ui_common);

// EXTERNAL MODULE: ./node_modules/_mint-ui@2.2.13@mint-ui/lib/style.css
var style = __webpack_require__("5OHe");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/_vue-clipboard2@0.0.8@vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("+4oL");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// CONCATENATED MODULE: ./src/utils/publicAPI.js

/**
 * Created by hcy on 2017/11/30.
 */

// refreshToken         刷新token
// imgCode              生成图片验证码
// smsCode              发送验证码
// getCode              码值表
// getIsOpenEncrypt     是否开启AES加密解密
//  sceneId:业务场景id  mobile:手机号 userId:用户id

// 调用方法  this.refreshToken ()
/* harmony default export */ var publicAPI = ({
  install: function install(Vue, options) {
    Vue.prototype.getIOSInfo = function (callback) {
      var self = this;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        self.$bridge.callhandler('getBanerLoginInfo', { 'success': 'success' }, function (data) {
          var res = data;
          if (!self.$utils.isnull(res)) {
            var appInfo = JSON.parse(res);
            localStorage.banner_uid = appInfo.userId;
            localStorage.banner_token = appInfo.token;
            sessionStorage.banner_channel = appInfo.channel;
          }
          callback && callback();
        });
        if (sessionStorage.banner_channel !== '02') {
          callback && callback();
        }
      } else {
        callback && callback();
      }
    };
    Vue.prototype.refreshToken = function () {
      this.axios.post('/baner/00_0002.do').then(function (res) {
        var state = res.data.head._rd;
        if (state === '0000') {
          var token = res.data.body.newToken;
          localStorage.setItem('token', token);
          return token;
        }
      }).catch(function (error) {
        console.log(error);
      });
    };
    Vue.prototype.smsCode = function (sceneId, mobile, userId, cardNo) {
      this.axios.post('/baner/00_0007.do', {
        sceneId: sceneId,
        mobile: mobile,
        userId: userId
      }).then(function (res) {
        var state = res.data.head._rd;
        if (state === '0000') {
          switch (sceneId) {
            case '005':
              var url = document.URL;
              if (url.indexOf('localhost') !== -1) {
                location.href = 'http://localhost:8080/#/MyBankCard/AddBankCardC/' + cardNo + '/' + mobile + '/' + false;
              } else {
                location.href = window.rootUrl + '/#/MyBankCard/AddBankCardC/' + cardNo + '/' + mobile + '/' + false;
              }
              break;
            case '006':
              return true;
            default:
              break;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    };
    Vue.prototype.getCode = function () {
      this.axios.post('/baner/00_0001.do').then(function (res) {
        var state = res.data.head._rd;
        if (state === '0000') {
          sessionStorage.banner_code = stringify_default()(res.data.body.params);
        }
      }).catch(function (error) {
        console.log(error);
      });
    };
    Vue.prototype.imgCode = function (sceneId, mobile, userId) {
      sessionStorage.setItem('code', '0006');
      this.axios.post('/baner/00_0006.do', {
        sceneId: sceneId,
        mobile: mobile,
        userId: userId
      }).then(function (res) {
        console.log(res);
        var state = res.data.head._rd;
        if (state === '0000') {
          var picStr = res.data.body.picStr;
          return picStr;
        }
      }).catch(function (error) {
        console.log(error);
      });
    };
  }
});
// CONCATENATED MODULE: ./src/utils?v=1.0

/**
 * Created by hcy on 2017/11/21.
 */

// goodTime     格式化时间
// isMobile     验证手机号
// isnull       是否为空
// isCard       验证银行卡号
// codeTimeout  发送验证码倒计时
// isLetter     验证纯字母
// isNumber     验证纯数字
// getUrlParam  获取浏览器地址栏参数
// Encrypt      aes加密
// Decrypt      aes解密
// getCitycodeName  根据citycode值获取城市名字
// isEmail       邮箱验证
// isNumerAZ     数字字母
// isID          身份证号
// ispostalCode  邮政编码
// getDate       截取年月日

/* harmony default export */ var utils_v_1 = ({
  goodTime: function goodTime(str) {
    var now = new Date().getTime();
    var oldTime = new Date(str).getTime();
    var difference = now - oldTime;
    var result = '';
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var month = day * 30;
    var year = month * 12;
    var _year = difference / year;
    var _month = difference / month;
    var _week = difference / (7 * day);
    var _day = difference / day;
    var _hour = difference / hour;
    var _min = difference / minute;

    if (_year >= 1) {
      result = '发表于 ' + ~~_year + ' 年前';
    } else if (_month >= 1) {
      result = '发表于 ' + ~~_month + ' 个月前';
    } else if (_week >= 1) {
      result = '发表于 ' + ~~_week + ' 周前';
    } else if (_day >= 1) {
      result = '发表于 ' + ~~_day + ' 天前';
    } else if (_hour >= 1) {
      result = '发表于 ' + ~~_hour + ' 个小时前';
    } else if (_min >= 1) {
      result = '发表于 ' + ~~_min + ' 分钟前';
    } else {
      result = '刚刚';
    }
    return result;
  },
  formatDate: function formatDate(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + m + d;
  },
  formatDate2: function formatDate2(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '年' + m + '月' + d + '日';
  },
  formatDate3: function formatDate3(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  },
  getFormatTime: function getFormatTime(str) {
    var time = str.substring(0, 4) + '年' + str.substring(5, 7) + '月' + str.substring(8, 10) + '日' + ' ' + str.substring(11, 16);
    return time;
  },
  getUrlParam: function getUrlParam(argName) {
    var args = location.href.split('?');
    var retval = '';
    var str = decodeURI(args[1]);
    if (str) {
      var _args = str.split('#')[0];
      args = _args.split('&');
      for (var i = 0; i < args.length; i++) {
        _args = args[i];
        var arg = _args.split('=');
        if (arg.length <= 1) {
          continue;
        }
        if (arg[0] === argName) {
          retval = arg[1];
        }
      }
    }
    return retval;
  },
  getCitycodeName: function getCitycodeName(code, proideList) {
    if (!this.isnull(code)) {
      var bb = code.substr(0, 4) + '00';
      var cc = code.substr(0, 2) + '0000';
      for (var i = 0; i < proideList.length; i++) {
        if (proideList[i].code === cc) {
          for (var j = 0; j < proideList[i].childrenList.length; j++) {
            if (proideList[i].childrenList[j].code === bb) {
              for (var g = 0; g < proideList[i].childrenList[j].childrenList.length; g++) {
                if (proideList[i].childrenList[j].childrenList[g].code === code) {
                  return proideList[i].name + ' - ' + proideList[i].childrenList[j].name + ' - ' + proideList[i].childrenList[j].childrenList[g].name;
                }
              }
            }
          }
        }
      }
    } else {
      return '';
    }
  },
  getWechatConfig: function getWechatConfig() {
    var url = window.location.href;
    window.$.ajax({
      type: 'POST',
      url: window.rootUrl + '/baner/00_1003.do',
      dataType: 'json',
      async: false,
      data: {
        'url': url
      },
      timeout: 35 * 1000,
      cache: false,
      complete: function complete(XMLHttpRequest, status) {},
      beforeSend: function beforeSend(XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader('Cache-Control', 'no-cache');
      },
      error: function error(XMLHttpRequest, status, thrownError) {
        var div = document.createElement('div');
        div.setAttribute('id', 'error');
        div.innerHTML = '<div class="ui-poptips-n ui-poptips-success"><div class="ui-poptips-cnt margin-lr-5">获取微信签名失败,请重试!</div></div>';
        document.getElementById('app').appendChild(div);
        setTimeout(function () {
          var errorId = document.getElementById('error');
          document.getElementById('app').removeChild(errorId);
        }, 2000);
      },
      success: function success(resp) {
        var appid = resp.appid;
        var timestamp = resp.timestamp;
        var nonceStr = resp.nonceStr;
        var signature = resp.signature;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: ['checkJsApi', 'scanQRCode', 'closeWindow', 'translateVoice', 'chooseImage', 'getLocalImgData', 'previewImage', 'uploadImage', 'downloadImage', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      }
    });
  },
  getWechatUserInfo: function getWechatUserInfo() {
    window.$.ajax({
      type: 'POST',
      url: window.rootUrl + '/baner/00_1004.do',
      dataType: 'json',
      async: false,
      data: {
        'openid': localStorage.openid
      },
      timeout: 35 * 1000,
      cache: false,
      complete: function complete(XMLHttpRequest, status) {},
      beforeSend: function beforeSend(XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader('Cache-Control', 'no-cache');
      },
      error: function error(XMLHttpRequest, status, thrownError) {
        var div = document.createElement('div');
        div.setAttribute('id', 'error');
        div.innerHTML = '<div class="ui-poptips-n ui-poptips-success"><div class="ui-poptips-cnt margin-lr-5">获取用户信息失败,请重试!</div></div>';
        document.getElementById('app').appendChild(div);
        setTimeout(function () {
          var errorId = document.getElementById('error');
          document.getElementById('app').removeChild(errorId);
        }, 2000);
      },
      success: function success(resp) {
        localStorage.wechatUserInfo = stringify_default()(resp);
      }
    });
  },
  getCode: function getCode(str) {
    var parms = JSON.parse(sessionStorage.banner_code);
    var codeArry = [];
    for (var i = 0; i < parms.length; i++) {
      if (parms[i].paramId === str) {
        codeArry.push(parms[i]);
      }
    }
    return codeArry;
  },
  getBodyBgFFF: function getBodyBgFFF() {
    var div = document.getElementsByTagName('body')[0];
    var height = window.innerHeight + 'px';
    div.style.height = height;
    div.style.backgroundColor = '#FFF';
  },
  getBodyBgF8: function getBodyBgF8() {
    var div = document.getElementsByTagName('body')[0];
    var height = window.innerHeight + 'px';
    div.style.height = height;
    div.style.backgroundColor = '#F8F8F8';
  },
  getDate: function getDate(val) {
    if (!this.isnull(val)) {
      return val.substring(0, 10);
    }
  },
  isMobile: function isMobile(str) {
    var reg = /^1[3|5|7|8]\d{9}$/;
    return reg.test(str);
  },
  isphoneNo: function isphoneNo(str) {
    var reg = /0\d{2}-\d{7,8}/;
    return reg.test(str);
  },
  isAllphoneNo: function isAllphoneNo(str) {
    var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
    return reg.test(str);
  },
  isHomeArea: function isHomeArea(str) {
    var reg = /^\d+(\.\d+)?$/;
    return reg.test(str);
  },
  isnull: function isnull(str) {
    return str == null || str === 'null' || typeof str === 'undefined' || str === '';
  },
  isCard: function isCard(str) {
    var reg = /^(\d{16}|\d{19})$/;
    return reg.test(str);
  },
  isVerCode: function isVerCode(str) {
    if (str.length === 6) {
      return true;
    } else {
      return false;
    }
  },
  isNumber: function isNumber(str) {
    var reg = /^[0-9]*$/;
    return reg.test(str);
  },
  isLetter: function isLetter(str) {
    var reg = /^[a-zA-Z]+$/;
    return reg.test(str);
  },
  isID: function isID(str) {
    var reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
    return reg.test(str);
  },
  ispostalCode: function ispostalCode(str) {
    var reg = /^[1-9][0-9]{5}$/;
    return reg.test(str);
  },
  isObjnull: function isObjnull(obj) {
    var i = '';
    for (i in obj) {
      if (obj[i] === 'null' || obj[i] === null) {
        obj[i] = ' ';
      }
    }
  },
  isCardNum18: function isCardNum18(obj) {
    var reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    return reg.test(obj);
  },
  isCardNum15: function isCardNum15(obj) {
    var reg = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
    return reg.test(obj);
  },
  isEmail: function isEmail(obj) {
    var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return reg.test(obj);
  },
  isNumerAZ: function isNumerAZ(str) {
    var reg = /^[A-Za-z0-9]+$/;
    return reg.test(str);
  },
  isAge: function isAge(str) {
    var reg = /^[0-9]{1,2}$/;
    return reg.test(str);
  },
  iswechat: function iswechat() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/micromessenger/i) == 'micromessenger';
  },
  isIOS: function isIOS() {
    var ua = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    return ua;
  },
  isAndroid: function isAndroid() {
    var ua = /(Android)/i.test(navigator.userAgent);
    return ua;
  },
  getBindCardUrl: function getBindCardUrl() {
    // 我要办卡地址
    var bindCardUrl = 'https://creditcard.cmbc.com.cn/wsv2/?enstr=j6zQQpKLvA5X%2f0wcJaZMb2EhOWpltJeY4UTurBOL6qdq7Mt7hTPzeAQ%2bwGqOCHuMqiGLzNbRlpjE%2fjbq4Fpgn%2bwrDbINI1khJCjgmwJ2Ai45wVATUnIOT8NUuNWNGLgKFosJKX%2b6Fi8csmjSnfbswXHFSW7UErt3U1BZZrvIc07E8Y%2f5XDJMfTroVIk%2ff11yJXuGmg5x1kFil2KXG5Rnr89c%2fVNycZuUtKOdz58y5da2YmgDHui0Qmpx%2byoVMXH1JSJ2cMAyiL%2fN1FpbVRMtuj7yVyG5Md2LhHUgANHp5EujN0sCaoQH2lRVA%2f1u%2bF7SIyiE8nfwX%2b95mlbFH0wraw%3d%3d';
    return bindCardUrl;
  }
});
// CONCATENATED MODULE: ./src/utils/bridge.js?v=1.0
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}
/* harmony default export */ var bridgev_1 = ({
  callhandler: function callhandler(name, data, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler(name, data, callback);
    });
  },
  registerhandler: function registerhandler(name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        callback(data, responseCallback);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/main.js
















// 加载router配的标题
router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

vue_esm["default"].use(mint_ui_common_default.a);
vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].use(publicAPI);
vue_esm["default"].use(vuex_esm["a" /* default */]);
vue_esm["default"].use(vue_clipboard_default.a);

// 将公共方法绑定到全局
vue_esm["default"].prototype.axios = _axios_0_17_1_axios_default.a;
vue_esm["default"].prototype.$utils = utils_v_1;
vue_esm["default"].prototype.$bridge = bridgev_1;

// 测试环境地址
_axios_0_17_1_axios_default.a.defaults.timeout = 30000;
_axios_0_17_1_axios_default.a.defaults.withCredentials = true;
// let rootUrl = 'http://ifreabsms1.chinacloudapp.cn'
var rootUrl = 'https://www.ibaner.com.cn';
window.rootUrl = rootUrl;
// Add a request interceptor
_axios_0_17_1_axios_default.a.interceptors.request.use(function (config) {
  window.banner_uid = localStorage.banner_uid;
  window.banner_token = localStorage.banner_token;
  var url = config.url || '';
  var code = url.substring(10, 14) || '';
  // Do something before request is sent
  config.headers['Content-Type'] = 'application/json';
  config.headers['Cache-Control'] = 'no-cache';
  config.headers['_tm'] = new Date().getTime();
  config.headers['_cn'] = sessionStorage.banner_channel || '00';
  config.headers['versionNumber'] = '1.0.1';
  config.headers['_si'] = code;
  // 积分接口07传APP或第三方登录信息
  if (code.substring(0, 2) === '07' || code === '0000' || code === '0001') {
    config.headers['_tn'] = window.banner_token || '';
    config.headers['_ui'] = window.banner_uid || '';
  } else {
    var _token = window.banner_token || '';
    var _uid = window.banner_uid || '';
    var _openid = localStorage.openid || '';
    config.headers['_tn'] = _token || '';
    config.headers['_ui'] = _uid || '';
    config.headers['_ci'] = _openid || '';
  }
  // 是否开启AES加密 openEncrypt 为0开启加密
  if (!utils_v_1.isnull(config.data) && sessionStorage.openEncrypt === '0') {
    // 系数（前后端提前约定好）
    var decIv = '0102030405060708';
    // 1.对明文进行加签（就是 对明文（报文+系数）做md5加密）
    var singStr = window.md5(stringify_default()(config.data) + decIv).toUpperCase();
    // 对明文报文做AES加密,再做转换成base64流
    var axiosData = stringify_default()(config.data);
    var eDataAes = window.encrypt(axiosData);
    var eData = eDataAes.toString();
    config.data = { 'dataSign': singStr, 'dataReq': eData };
  }
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});
// 拦截未登录
_axios_0_17_1_axios_default.a.interceptors.response.use(function (res) {
  // Do something with response data
  var response = '';
  if (res.config.headers._si === '0000' || res.config.headers._si === '1003') {
    response = res;
    return response;
  } else {
    // AES解密  是否开启解密
    if (sessionStorage.openEncrypt === '0') {
      var resData = res.data.dataResp;
      response = { data: JSON.parse(window.decrypt(resData)) };
    } else {
      response = res;
    }
    var _resrd = void 0;
    if (!utils_v_1.isnull(response.data.appid)) {
      _resrd = '';
    } else {
      _resrd = response.data.head._rd;
    }
    var _resrm = response.data.head._rm;
    var url = document.URL;
    // 0001 8002 8003 未登录  8001 刷新token
    if (_resrd === '0001' || _resrd === '8002' || _resrd === '8003' || _resrd === '8000') {
      var hash = location.hash;
      if (hash.indexOf('return_url') === -1) {
        if (url.indexOf('localhost') !== -1) {
          location.href = 'http://localhost:8080/#/Login/Login';
        } else {
          location.href = window.rootUrl + '/#/Login/Login';
        }
      }
    } else if (_resrd === '8001') {
      this.axios.post('/baner/00_0002.do').then(function (res) {
        var state = res.data.head._rd;
        if (state === '0000') {
          var token = res.data.body.newToken;
          localStorage.setItem('token', token);
          return token;
        }
      }).catch(function (error) {
        console.log(error);
      });
      // 022007 文章已经被删除，该错误在详细页面处理，这里不做拦截处理 或0123接口
    } else if (_resrd === '022007' || _resrd === '1002' || _resrd === '0003') {
      console.log();
    } else if (_resrd !== '0000') {
      Object(mint_ui_common["Toast"])({
        message: _resrm,
        duration: 2000
      });
    }
    return response;
  }
}, function (error) {
  var url = document.URL;
  if (url.indexOf('localhost') !== -1) {
    location.href = 'http://localhost:8080/#/Error';
  } else {
    location.href = window.rootUrl + '/#/Error';
  }
  // Do something with response error
  return promise_default.a.reject(error);
});
vue_esm["default"].config.productionTip = false;
/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "of87":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.24abe043ceaebcf2d8da.js